import React from "react";

export default function PayHereCancel() {
  return (
    <div style={{ padding: 24 }}>
      <h2>Payment cancelled</h2>
      <p>You can try again anytime.</p>
    </div>
  );
}
